"use client"
import React, { createContext, useState, useContext, ReactNode, Fragment } from 'react';
import { Snackbar, AlertColor, Box, SlideProps, Slide } from '@mui/material';
import { Alert } from '@itlogix/itlogix-ui';

type AlertContextType = {
    showSnackbar: (message: string, severity: AlertColor) => void;
};

const AlertContext = createContext<AlertContextType | undefined>(undefined);
export const useSnackbar = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useSnackbar deve essere utilizzato all\'interno di un SnackbarProvider');
    }
    return context;
};

function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}


export const AlertProvider = ({ children }: { children: ReactNode }) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>('success');

    const showSnackbar = (message: string, severity: AlertColor) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    return (
        <AlertContext.Provider value={{ showSnackbar }}>
            {children}
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackbarOpen}
                autoHideDuration={10000}
                onClose={handleCloseSnackbar}
                TransitionComponent={SlideTransition} // Utilizza la stessa transizione per apertura/chiusura
            >
                <Box>
                    {snackbarOpen && (
                        <Alert
                            onClose={handleCloseSnackbar}
                            severity={snackbarSeverity}
                            sx={{ width: '100%' }}
                        >
                            {snackbarMessage}
                        </Alert>
                    )}
                </Box>
            </Snackbar>

        </AlertContext.Provider>
    );
};
